// The sidebar: one "main" group holding the eight sections, plus a separate
// untitled "admin" group so Admin renders below the design's divider.
//
// Each section entry expands to that section's own tabs, so the sub-navigation
// the design moved into the page is reachable from the sidebar too — for QIC
// that is its event years, which live in the database, hence the `qicYears`
// argument. MenuList subscribes to them and passes them in; with none, QIC
// renders flat rather than as an expander that opens nothing.
//
// `qicEvents` is the same fetch's event rows and is what says which of those
// years is the running championship, so the sidebar can mark it the way the
// in-page strip does. Both come from one dispatch, so they arrive together.
//
// The unwired group files this folder used to carry — Stocks, QIC, QIChamp,
// Learning, MyActions, Market_dashboard, and the stock demo menus — were deleted
// on 2026-09-22. Nothing imported any of them, so each was dead weight. Profile.js
// and sectionTabs.js survive here because something still imports them
// (Personal-Dashboard, and dhruvaMain respectively), as do this file, Admin.js,
// CnAdmin.js and dhruvaMain.js.
import CNAdmin from "./CnAdmin";
import { buildMain, buildAdmin } from "./dhruvaMain";
// ==============================|| MENU ITEMS ||============================== //

const getMenuItems = (qicYears = [], qicEvents = []) => {
  const main = buildMain(qicYears, qicEvents);
  // Built once per call rather than at each of the four sites below. It is
  // memoised on the admin tree's identity, so calling it repeatedly would be
  // correct but would re-read and re-parse localStorage each time.
  const admin = buildAdmin();
  const Usersid = window.localStorage.getItem("users");

  // Default menu for non-logged in users
  let menuItems = {
    items: [main],
  };

  if (Usersid) {
    try {
      const { role_id, cn_role_id } = JSON.parse(Usersid);

      // Clear, non-overlapping role logic with proper precedence.
      // Conditions are unchanged from before the redesign — only the member
      // items they swap in are different, so role gating behaves as it did.
      if (role_id !== 1) {
        menuItems = {
          items: [main],
        };
      }
      if ((role_id !== 1 && cn_role_id === 3) || cn_role_id === 2) {
        menuItems = {
          items: [main, CNAdmin],
        };
      }
      if (
        role_id === 1 ||
        (role_id === 2 && (cn_role_id === 3 || cn_role_id === 2))
      ) {
        menuItems = {
          items: [main, admin],
        };
      }
      if (role_id === 1 || role_id === 2) {
        menuItems = {
          items: [main, admin],
        };
      }
      if (role_id === 3 && (cn_role_id === 3 || cn_role_id === 2)) {
        menuItems = {
          items: [main, admin],
        };
      }
      if (role_id === 3) {
        menuItems = {
          items: [main, admin],
        };
      }
    } catch (error) {
      console.error("Error parsing user data from localStorage:", error);
      // Return default menu items if parsing fails
    }
  }

  return menuItems;
};

// Export a function that can be called dynamically
export default getMenuItems;
